import styled from '@emotion/styled';
import { Popover } from '../../../base/popover';
import { Variables } from '../../../base/variables';

// Floats above the page, bottom-right, whenever table rows are selected — the same spot the
// support claims list (`claims-list/actions.tsx`'s `S.ActionsContainer`) puts its batch menu.
export const FabContainer = styled.div`
    position: fixed;
    right: 50px;
    bottom: 50px;
    z-index: 1;
`;

export const FabPopover = styled(Popover)`
    display: inline-flex;
`;

export const FabMenuLabel = styled.div`
    padding: 8px 16px;
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMedium};
    white-space: nowrap;
`;
